export default {
  namespaced: true,
  state: () => ({
    isSidebarOpen: true,
    isLoading: false,
  }),
  mutations: {
    toggleSidebar(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    setSidebar(state, value) {
      state.isSidebarOpen = value;
    },
    setLoading(state, value) {
      state.isLoading = value;
    }
  },
  getters: {
    isSidebarOpen: state => state.isSidebarOpen,
    isLoading: state => state.isLoading
  }
}